import React, { useRef, useEffect } from "react";
import { Form } from "react-bootstrap";

export const AutoCompleteValue = "off"; //new-password for chrome

const InputFormFocus = ({
  value,
  placeholder,
  isDisabled = false,
  textArea = false,
  onChange = null,
  rows = 2,
  type = "text",
  maxlength = null,
  ...rest
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    // Focus the input element when the component mounts
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <>
      {textArea ? (
        <Form.Control
          ref={inputRef}
          placeholder={placeholder}
          value={value ?? ""}
          disabled={isDisabled}
          onChange={onChange}
          as="textarea"
          rows={rows}
          type={type}
          maxLength={maxlength}
          {...rest}
        />
      ) : (
        <Form.Control
          ref={inputRef}
          placeholder={placeholder}
          value={value ?? ""}
          autoComplete={AutoCompleteValue}
          disabled={isDisabled}
          onChange={onChange}
          type={type}
          maxLength={maxlength}
          {...rest}
        />
      )}
    </>
  );
};

export default InputFormFocus;
